<template>
  <div>
    <div>
      <b-form-input
        placeholder="Buscar por departamento o nombre"
        v-model="criterion"
        class="mb-4"
      >
      </b-form-input>
    </div>
    <b-table
      sticky-header
      hover
      small
      responsive="md"
      :items="list"
      :fields="fields"
      :per-page="request.cantidad"
      striped
    >
      <template #cell(id)="data">
        <span class="text-primary">{{ data.item.id }}</span>
      </template>
      <template #cell(name)="data">
        <span class="">{{ data.item.nombre }}</span>
      </template>
      <template #cell(departament)="data">
        <span class="">{{ data.item.departamento }}</span>
      </template>
      <template #cell(sucursal)="data">
        <span class="">{{ data.item.sucursal }}</span>
      </template>
      <template #cell(descripcion)="data">
        <span class="">{{ data.item.descripcion }}</span>
      </template>
      <template #cell(status)="data">
        <b-badge class="p-2" :variant="ESTATUS[data.item.estatus].color">{{
          ESTATUS[data.item.estatus].text
        }}</b-badge>
      </template>
      <template #cell(input)="data">
        <b-button
          v-if="data.item.estatus == 'Disponible'"
          size="sm"
          variant="danger"
          @click="changeStatus(data.item.id)"
        >
          Deshabilitar</b-button
        >
        <b-button
          v-if="data.item.estatus == 'NoDisponible'"
          size="sm"
          variant="success"
          @click="changeStatus(data.item.id)"
        >
          Habilitar</b-button
        >
      </template>
    </b-table>

    <b-pagination
      :total-rows="cantidad"
      v-model="currentPage"
      first-number
      last-number
      align="right"
      prev-class="prev-item"
      next-class="next-item"
      :per-page="request.cantidad"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ESTATUS } from "../../utils/constants";

export default {
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "ID",
        },
        {
          key: "name",
          label: "Nombre",
        },
        {
          key: "departament",
          label: "Departamento",
        },
        {
          key: "sucursal",
          label: "Sucursal",
        },
        {
          key: "descripcion",
          label: "Descripcion",
        },
        {
          key: "status",
          label: "Estatus",
        },
        {
          key: "input",
          label: "",
        },
      ],
      ESTATUS: ESTATUS,
      criterion: "",
    };
  },
  async mounted() {
    await this.getList();
  },
  methods: {
    async changeStatus(id) {
      await this.$store
        .dispatch({ type: "vacant/changeStatus", id  })
        .then(async (resp) => {
          this.$swal.fire("Éxito", resp.message, "success");
          await this.getList();
        })
        .catch((e) => {
          this.$swal.fire("Error", e.message, "error");
        });
    },

    async getList() {
      
      await this.$store.dispatch({
        type: "vacant/getVacants",
        data: this.request,
      });
    },
  },
  computed: {
    ...mapState({
      list: (state) => state.vacant.responseListVacants.vacantes,
      cantidad: (state) => state.vacant.responseListVacants.cantidadVacante,
      request: (state) => state.vacant.requestListVacants,
    }),
    currentPage: {
      get: function() {
        return this.$store.state.vacant.requestListVacants.skip;
      },
      set: async function(value) {
        this.$store.commit("vacant/SET_SKIP", value);
        await this.getList();
      },
    },
  },
  watch: {
    async criterion(value) {
      this.$store.commit("vacant/SET_CRITERIO", value);
      await this.getList();
    },
  },
};
</script>
